var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_32027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.66667C10.5 2.0895 14.4177 0 19.25 0C24.0823 0 28 2.0895 28 4.66667C28 7.24383 24.0823 9.33333 19.25 9.33333C14.4177 9.33333 10.5 7.24383 10.5 4.66667ZM19.25 11.6667C18.0518 11.6667 16.9155 11.5325 15.8772 11.2992C14.2917 10.1103 11.6935 9.33333 8.75 9.33333C3.91767 9.33333 0 11.4228 0 14C0 16.5772 3.91767 18.6667 8.75 18.6667C13.5823 18.6667 17.5 16.5772 17.5 14C17.5 13.9662 17.4918 13.9335 17.4907 13.8997H17.5V16.3333C17.5 18.9105 13.5823 21 8.75 21C3.91767 21 0 18.9105 0 16.3333V18.6667C0 21.2438 3.91767 23.3333 8.75 23.3333C13.5823 23.3333 17.5 21.2438 17.5 18.6667V21C17.5 23.5772 13.5823 25.6667 8.75 25.6667C3.91767 25.6667 0 23.5772 0 21V23.3333C0 25.9105 3.91767 28 8.75 28C13.5823 28 17.5 25.9105 17.5 23.3333V23.24C18.0658 23.3007 18.6503 23.3333 19.25 23.3333C24.0823 23.3333 28 21.2438 28 18.6667V16.3333C28 18.8055 24.3927 20.8238 19.8333 20.9848V18.6515C24.3927 18.4905 28 16.4733 28 14V11.6667C28 14.1388 24.3927 16.1572 19.8333 16.3182V13.9848C24.3927 13.8238 28 11.8067 28 9.33333V7C28 9.57717 24.0823 11.6667 19.25 11.6667Z",
    fill: "#E5C25B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_32027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.c495f25ea369d619e8151954ab35f947.svg";
export { ForwardRef as ReactComponent };